import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as commonActions from "../../../../actions/common.actions";
import * as projectActions from "../../../../actions/project.actions";

import Candidates from "../components/candidates/Candidates";

const rejectedHeader = () => ({
  color: "grey",
  title: "This Project has Been Rejected by The Second Shift",
  text: (
    <span>
      If you believe this was done in error, please{" "}
      <b>
        <a href="https://thesecondshift.com/contact-us" target="_blank">
          contact us
        </a>
      </b>
      .
    </span>
  )
});
class ProjectCandidatesContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: null
    };

    this.declineCandidate = this.declineCandidate.bind(this);
    this.undoDecline = this.undoDecline.bind(this);
    this.onSort = this.onSort.bind(this);
  }

  componentWillUnmount() {
    this.props.commonActions.setHeaderBar({});
    this.props.commonActions.setSubHeader({});
  }

  componentDidMount() {
    this.props.projectActions.getProject(this.props.match.params.projectId);
    this.props.projectActions.getPitchesByProjectId(
      this.props.match.params.projectId
    );
  }

  declineCandidate(id, message) {
    const payload = {
      pitch_id: id,
      message: message,
      accept: false
    };

    this.props.projectActions.acceptPitch(
      payload,
      this.props.match.params.projectId
    );
  }

  undoDecline(pitchId) {
    this.props.projectActions.undoDeclinePitch(
      this.props.match.params.projectId,
      pitchId
    );
  }

  onSort(key) {
    this.props.projectActions.sortCandidates(key);
  }

  countHired = pitches => {
    var totalHired = 0;

    pitches.forEach(pitch => {
      if (pitch.accepted) {
        totalHired++;
      }
    });

    return totalHired;
  };

  countSelected = pitches => {
    var total = 0;

    pitches.forEach(pitch => {
      if (pitch.accepted === null) {
        total++;
      }
    });

    return total;
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.pitches !== nextProps.pitches) {
      const projectId = this.props.match.params.projectId;
      const pitches = nextProps.pitches;

      const subHeader = {
        items: [
          {
            caption: `Project Detail`,
            url: `/company/project/${projectId}`
          },
          {
            caption: `Candidates (${this.countSelected(pitches)})`,
            url: `/company/project/${projectId}/candidates`
          },
          {
            caption: `Selected (${this.countHired(pitches)})`,
            url: `/company/project/${projectId}/hired`
          }
        ],
        activeItem: 1,
        track: true
      };

      this.props.commonActions.setSubHeader(subHeader);
    }
  }

  componentDidUpdate(prevState) {
    this.setHeaderBar(prevState);
  }

  setHeaderBar(prevState) {
    const project = this.props.project;
    const status = _.get(project, "status.name");

    let headerBar = {};

    if (status) {
      switch (status) {
        case "rejected":
          headerBar = rejectedHeader();
          break;
      }
    }

    if (prevState.status && status !== prevState.status) {
      this.props.commonActions.setHeaderBar(headerBar);
      this.setState({ status });
    }
  }

  render() {
    return (
      <Candidates
        id={this.props.match.params.projectId}
        declineCandidate={this.declineCandidate}
        undoDecline={this.undoDecline}
        sortCandidates={this.onSort}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    pitches: state.project.pitches,
    sortedBy: state.project.sortedBy,
    project: state.project
  };
};

const mapDispatchToProps = dispatch => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
    projectActions: bindActionCreators(projectActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectCandidatesContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/projectInformation/containers/ProjectCandidatesContainer.js